/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CallidusBvsHaftpflichtUndKaskoMoeglicheSelbstbehalteResultDto } from '../model/callidus-bvs-haftpflicht-und-kasko-moegliche-selbstbehalte-result-dto.model';
// @ts-ignore
import { CallidusBvsVersicherungspraemieHaftpflichtCalcDto } from '../model/callidus-bvs-versicherungspraemie-haftpflicht-calc-dto.model';
// @ts-ignore
import { CallidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto } from '../model/callidus-bvs-versicherungspraemie-haftpflicht-und-kasko-calc-dto.model';
// @ts-ignore
import { ProductCallidusPipelineResultDto } from '../model/product-callidus-pipeline-result-dto.model';
// @ts-ignore
import { PublicCallidusBvsHaftpflichtContractCreateDto } from '../model/public-callidus-bvs-haftpflicht-contract-create-dto.model';
// @ts-ignore
import { PublicCallidusBvsHaftpflichtUndKaskoCalcResultDto } from '../model/public-callidus-bvs-haftpflicht-und-kasko-calc-result-dto.model';
// @ts-ignore
import { PublicCallidusBvsHaftpflichtUndKaskoContractCreateDto } from '../model/public-callidus-bvs-haftpflicht-und-kasko-contract-create-dto.model';
// @ts-ignore
import { VersicherungspraemieCalculationResultDto } from '../model/versicherungspraemie-calculation-result-dto.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PublicCallidusBvsApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint post /api/public-callidus-bvs/contract/haftpflicht
     * @param publicCallidusBvsHaftpflichtContractCreateDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicCallidusBvsContractHaftpflichtPost(publicCallidusBvsHaftpflichtContractCreateDto: PublicCallidusBvsHaftpflichtContractCreateDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProductCallidusPipelineResultDto>;
    public apiPublicCallidusBvsContractHaftpflichtPost(publicCallidusBvsHaftpflichtContractCreateDto: PublicCallidusBvsHaftpflichtContractCreateDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProductCallidusPipelineResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtPost(publicCallidusBvsHaftpflichtContractCreateDto: PublicCallidusBvsHaftpflichtContractCreateDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProductCallidusPipelineResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtPost(publicCallidusBvsHaftpflichtContractCreateDto: PublicCallidusBvsHaftpflichtContractCreateDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (publicCallidusBvsHaftpflichtContractCreateDto === null || publicCallidusBvsHaftpflichtContractCreateDto === undefined) {
            throw new Error('Required parameter publicCallidusBvsHaftpflichtContractCreateDto was null or undefined when calling apiPublicCallidusBvsContractHaftpflichtPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-callidus-bvs/contract/haftpflicht`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProductCallidusPipelineResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: publicCallidusBvsHaftpflichtContractCreateDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/public-callidus-bvs/contract/haftpflicht-und-kasko/moegliche-selbstbehalte
     * @param callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoMoeglicheSelbstbehaltePost(callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto: CallidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CallidusBvsHaftpflichtUndKaskoMoeglicheSelbstbehalteResultDto>;
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoMoeglicheSelbstbehaltePost(callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto: CallidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CallidusBvsHaftpflichtUndKaskoMoeglicheSelbstbehalteResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoMoeglicheSelbstbehaltePost(callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto: CallidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CallidusBvsHaftpflichtUndKaskoMoeglicheSelbstbehalteResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoMoeglicheSelbstbehaltePost(callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto: CallidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto === null || callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto === undefined) {
            throw new Error('Required parameter callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto was null or undefined when calling apiPublicCallidusBvsContractHaftpflichtUndKaskoMoeglicheSelbstbehaltePost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-callidus-bvs/contract/haftpflicht-und-kasko/moegliche-selbstbehalte`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CallidusBvsHaftpflichtUndKaskoMoeglicheSelbstbehalteResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/public-callidus-bvs/contract/haftpflicht-und-kasko
     * @param publicCallidusBvsHaftpflichtUndKaskoContractCreateDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoPost(publicCallidusBvsHaftpflichtUndKaskoContractCreateDto: PublicCallidusBvsHaftpflichtUndKaskoContractCreateDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProductCallidusPipelineResultDto>;
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoPost(publicCallidusBvsHaftpflichtUndKaskoContractCreateDto: PublicCallidusBvsHaftpflichtUndKaskoContractCreateDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProductCallidusPipelineResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoPost(publicCallidusBvsHaftpflichtUndKaskoContractCreateDto: PublicCallidusBvsHaftpflichtUndKaskoContractCreateDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProductCallidusPipelineResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoPost(publicCallidusBvsHaftpflichtUndKaskoContractCreateDto: PublicCallidusBvsHaftpflichtUndKaskoContractCreateDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (publicCallidusBvsHaftpflichtUndKaskoContractCreateDto === null || publicCallidusBvsHaftpflichtUndKaskoContractCreateDto === undefined) {
            throw new Error('Required parameter publicCallidusBvsHaftpflichtUndKaskoContractCreateDto was null or undefined when calling apiPublicCallidusBvsContractHaftpflichtUndKaskoPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-callidus-bvs/contract/haftpflicht-und-kasko`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProductCallidusPipelineResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: publicCallidusBvsHaftpflichtUndKaskoContractCreateDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/public-callidus-bvs/contract/haftpflicht-und-kasko/versicherungspraemie
     * @param callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoVersicherungspraemiePost(callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto: CallidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PublicCallidusBvsHaftpflichtUndKaskoCalcResultDto>;
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoVersicherungspraemiePost(callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto: CallidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PublicCallidusBvsHaftpflichtUndKaskoCalcResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoVersicherungspraemiePost(callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto: CallidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PublicCallidusBvsHaftpflichtUndKaskoCalcResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtUndKaskoVersicherungspraemiePost(callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto: CallidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto === null || callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto === undefined) {
            throw new Error('Required parameter callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto was null or undefined when calling apiPublicCallidusBvsContractHaftpflichtUndKaskoVersicherungspraemiePost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-callidus-bvs/contract/haftpflicht-und-kasko/versicherungspraemie`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PublicCallidusBvsHaftpflichtUndKaskoCalcResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: callidusBvsVersicherungspraemieHaftpflichtUndKaskoCalcDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/public-callidus-bvs/contract/haftpflicht/versicherungspraemie
     * @param callidusBvsVersicherungspraemieHaftpflichtCalcDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicCallidusBvsContractHaftpflichtVersicherungspraemiePost(callidusBvsVersicherungspraemieHaftpflichtCalcDto: CallidusBvsVersicherungspraemieHaftpflichtCalcDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VersicherungspraemieCalculationResultDto>;
    public apiPublicCallidusBvsContractHaftpflichtVersicherungspraemiePost(callidusBvsVersicherungspraemieHaftpflichtCalcDto: CallidusBvsVersicherungspraemieHaftpflichtCalcDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VersicherungspraemieCalculationResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtVersicherungspraemiePost(callidusBvsVersicherungspraemieHaftpflichtCalcDto: CallidusBvsVersicherungspraemieHaftpflichtCalcDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VersicherungspraemieCalculationResultDto>>;
    public apiPublicCallidusBvsContractHaftpflichtVersicherungspraemiePost(callidusBvsVersicherungspraemieHaftpflichtCalcDto: CallidusBvsVersicherungspraemieHaftpflichtCalcDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (callidusBvsVersicherungspraemieHaftpflichtCalcDto === null || callidusBvsVersicherungspraemieHaftpflichtCalcDto === undefined) {
            throw new Error('Required parameter callidusBvsVersicherungspraemieHaftpflichtCalcDto was null or undefined when calling apiPublicCallidusBvsContractHaftpflichtVersicherungspraemiePost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-callidus-bvs/contract/haftpflicht/versicherungspraemie`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VersicherungspraemieCalculationResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: callidusBvsVersicherungspraemieHaftpflichtCalcDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
